import React from 'react';
import * as R from 'ramda';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
import { ENUMS } from '../../../../constants/enums';
// ui
import { PlacesAutocomplete } from '../../../../ui';
//////////////////////////////////////////////////

const PlaceAutocomplete = (props) => {
  const {
    id,
    width,
    value,
    values,
    setValues,
    placeholder,
    omitAddress1,
    setFieldValue,
    setFieldTouched,
    useMenuPortalTarget,
    customSelectLocationFunction,
  } = props;

  const handleBlur = () => {
    setFieldTouched(id, true);
  };

  const handleChange = (value) => {
    setFieldValue(id, value);
  };

  const handleSelect = async (value) => {
    const result = await G.geocodeByPlaceAddress(value, 'new-do -> Fieldset');

    const data = {
      ...result,
      label: id,
      [GC.FIELD_LOAD_BOARD_ORIGIN_CITY]: G.getPropFromObject('city', result), // TODO: check why it is here
    };

    const newValues = G.isTrue(omitAddress1) ? R.omit([GC.FIELD_ADDRESS_1], data) : data;

    if (G.isFunction(customSelectLocationFunction)) {
      return customSelectLocationFunction(newValues);
    }

    const branchConfigs = G.getItemFromWindow('amousNewDoBranchConfigs');
    const manageTrailersFrom = G.getConfigValueFromStore(GC.TRAILER_MANAGE_TRAILERS_FROM, branchConfigs);

    const useStopTrailers = R.equals(manageTrailersFrom, ENUMS.ENUM_EVENTS);

    const trailerFields = useStopTrailers ? {} : {
      [GC.FIELD_STOP_DROPPED_TRAILER_GUIDS]: [],
      [GC.FIELD_STOP_PICKED_UP_TRAILER_GUIDS]: [],
    };

    setValues({
      ...R.or(values, {}),
      ...newValues,
      ...trailerFields,
      [GC.FIELD_TEMPLATE_ID]: '',
      [GC.FIELD_TEMPLATE_GUID]: '',
      [GC.FIELD_DROP_TRAILER]: false,
    }, id);
  };

  return (
    <PlacesAutocomplete
      id={id}
      width={width}
      value={value}
      handleBlur={handleBlur}
      placeholder={placeholder}
      handleSelect={handleSelect}
      handleChange={handleChange}
      setFieldValue={setFieldValue}
      useMenuPortalTarget={useMenuPortalTarget}
    />
  );
};

export default PlaceAutocomplete;
